export default function ReferralsPage() {
  return <div style={{ padding: 30 }}><h1>Referrals</h1><p>Coming soon...</p></div>;
}
